var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2016.97 -6308.786 23.716 23.716",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-8 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_214118_cc",
    className: "cls-7",
    transform: "translate(-2016.97 -6308.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-8",
    d: "M12.446,11.745H18.4c.153,0,.278.188.278.423a.423.423,0,0,1-.421.423H12.279a.419.419,0,0,1-.288-.114l-.013-.012L7.335,8.136a.423.423,0,0,1,.578-.619ZM3.621,20.388A11.858,11.858,0,1,0,3.328,3.621,11.858,11.858,0,0,0,3.621,20.388Zm.392-.406A11.293,11.293,0,1,0,3.734,4.013,11.293,11.293,0,0,0,4.013,19.982Z",
    transform: "translate(0 0)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.b7a301c8.svg";
export { ForwardRef as ReactComponent };